module.exports = __webpack_public_path__ + "static/sample_Contents-8fd4cc4ce632e6896ee0d1c8136cef69.png";